<template>
<div>
  <div id="preloader">
    <Loading />
  </div>
  <transition v-on:enter="pageLoad">
    <div v-if="menuReady" class="menuApp">
      <Topbar :navAvail='navAvail' :btqMenu='btqMenu.menus' :languages="btqMenu.languages" />
      <div class="foodmenu_Wrapper" id="top">
        <Lecafe v-if="btqMenu.introEnabled" :leCafeMarkup="btqMenu.intro" />
        <div v-if="menuReady">
          <BtqMenu :btqMenu='btqMenu.menus' />
        </div>
      </div>
      <Footer :navAvail='navAvail' />
    </div>
  </transition>
</div>
</template>
<script>
import Loading from '@/components/loading.vue';
import Topbar from '@/components/topbar.vue';
import Lecafe from '@/components/lecafe.vue';
import BtqMenu from '@/components/menu_full.vue';
import Footer from '@/components/footer.vue';

export default {
  name: 'Menu',
  components: {
    Loading,
    Topbar,
    Lecafe,
    BtqMenu,
    Footer
  },
  data() {
    return {
      btqMenu: null,
      navAvail: false,
      menuReady: false
    }
  },
  created: function() {

  },

  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData(){
      let boutique = this.$route.params.boutique;
      let lang = this.$route.query.lang;

      if (this._.isUndefined(lang) || lang == "" || lang == null){
        lang = "en";
      }
    this.axios.get("menus/" + boutique + "/" + lang + ".json")
      .then(response => {
        this.btqMenu = response.data;
        this.navAvail = true;
        this.menuReady = true;
        if (this.btqMenu.language != "en"){
          document.documentElement.setAttribute('lang',this.btqMenu.language)
        }
      }).catch((error) => {
        this.menuReady = true;
        console.log("Error", error)
      });
    },
    pageLoad: function(el, done) {

      let timeline = new this.TimelineLite({onComplete: destroyLoader});
      let jumbotron = document.getElementById("jumbotron");
      let logo = document.getElementById("logo_Container");
      let preloader = document.getElementById("preloader");
      timeline.set(el, {opacity:0});
      timeline.set(jumbotron, {opacity:0});
      timeline.set(logo, {opacity:0});
      timeline.to(jumbotron, 0.5, {opacity: 1});
      timeline.to(logo, 0.35, {opacity: 1}, 0.1);
      // load content
      timeline.to(el, 1.5, {opacity: 1}, 2);
      // Remove
      timeline.to(preloader, 0.75, {opacity: 0}, 2);

      function destroyLoader(){
        preloader.remove();
        done();
      }
    },
  },
  watch: {
    '$route.query.lang': function () {
      this.fetchData();
    }
  },
}
</script>
